import { use, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../styles/Invoice.css";

export default function Invoice() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [booking, setBooking] = useState(null);
  const [printMode, setPrintMode] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/bookings/${id}`,
          {
            credentials: "include",
          },
        );
        const data = await res.json();

        if (!res.ok) throw new Error(data.message);

        setBooking(data.booking);
      } catch (err) {
        toast.error(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBooking();
  }, [id]);

  useEffect(() => {
    if (!booking) return;

    if (Number(booking.paidCost) >= 100) {
      setPrintMode("full-paid-deposit");
    } else {
      setPrintMode("full");
    }
  }, [printMode, booking]);

  if (loading) return <div>Loading invoice...</div>;
  if (!booking) return <div>Booking not found</div>;

  const handlePrintFull = () => {
    setTimeout(() => {
      window.print();
    }, 100);
  };

  const handlePrintFinalStatement = () => {
    setPrintMode("statement");

    setTimeout(() => {
      window.print();
    }, 100);
  };

  const dueDate = booking?.picnicDate ? new Date(booking.picnicDate) : null;

  const formattedDueDate = dueDate
    ? new Date(dueDate.getTime() - 3 * 24 * 60 * 60 * 1000)
    : null;

  return (
    <div className="invoice__container">
      <div className="invoice__paper">
        <h1>Bribie Island Picnics</h1>
        <div className="invoice__booking--details">
          <h2>Booking Invoice/Receipt</h2>
          <h2>{booking.invoiceNumber}</h2>
        </div>
        <div className="invoice_addressing--container">
          <ul className="invoice_addressing--customer-details">
            <li>{booking.name}</li>
            <li>
              <strong>Ph: </strong> {booking.phone}
            </li>
            <li>
              <strong>Email:</strong> {booking.email}
            </li>

            <li>
              <strong>Picnic Date: </strong>
              {new Date(booking.picnicDate).toLocaleString("en-Au", {
                timeZone: "Australia/Brisbane",
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })}
            </li>
            <li>
              {" "}
              <strong>Preferred Location: </strong> {booking.preferredLocation}
            </li>
            <li className="invoice__date--row">
              <strong>Date: </strong>
              {new Date().toLocaleDateString("en-Au", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                timeZone: "Australia/Brisbane",
              })}
            </li>
          </ul>
          <ul className="invoice_addressing--business-details">
            <li>Ali Croning</li>
            <li>ABN: 61770106848</li>
            <li>Ph: 0493 294 665</li>
            <li>Email: enquire@bribieislandpicnics.com.au</li>
          </ul>
        </div>
        {/* Main detail & pricing */}
        <table className="invoice__main--container">
          <tbody>
            <tr>
              <td>
                <strong>Picnic Type:</strong>
              </td>
              <td>{booking.picnicSetting}</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <strong>Picnic Style:</strong>
              </td>
              <td>{booking.picnicStyle}</td>
              <td></td>
            </tr>

            <tr>
              <td>
                <strong>Celebration Type:</strong>
              </td>
              <td>{booking.celebrationType}</td>
              <td></td>
            </tr>

            <tr>
              <td>
                <strong>Number of Guests:</strong>
              </td>
              <td>{booking.guestNo}</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <strong>Event Inclusions:</strong>
              </td>
              <td>{(booking.eventInclusions || []).join(", ")}</td>
              <td>${booking.inclusionsCost}</td>
            </tr>
            <tr>
              <td>
                <strong>Additions</strong>
              </td>
              <td>
                <ul>
                  {(booking.additions || []).map((a, i) => (
                    <li key={i}>
                      {a.name}: {a.quantity} x ${a.price}
                    </li>
                  ))}
                  <li style={{ textAlign: "right", fontWeight: "bold" }}>
                    Additions Cost:
                  </li>
                </ul>
              </td>

              <td style={{ verticalAlign: "bottom" }}>
                ${booking.additionsCost}
              </td>
            </tr>
            <tr>
              <td></td>
              <td style={{ textAlign: "right" }}>
                <strong>Total:</strong>
              </td>
              <td>${booking.totalCost}</td>
            </tr>
            <tr>
              <td></td>
              <td style={{ textAlign: "right" }}>
                <strong>Paid:</strong>
              </td>
              <td>${booking.paidCost}</td>
            </tr>
            <tr>
              <td></td>
              <td style={{ textAlign: "right" }}>
                <strong>Balance:</strong>
              </td>
              <td>${booking.balanceCost}</td>
            </tr>
          </tbody>
        </table>

        <div className="invoice__addtional--notes">
          <p>
            <strong>Additional Notes: </strong>
            {booking.additionalNotes}
          </p>
        </div>
        <div className="invoice__payment-information--container">
          <p>
            THANK YOU FOR INVITING BRIBIE ISLAND PICNICS TO BE PART OF YOUR VERY
            SPECIAL CELEBRATION
          </p>
        </div>
        {printMode === "full-paid-deposit" && (
          <div className="invoice__payment-information--container1">
            <div className="invoice__payment--container">
              <h3>Payment: Direct Deposit</h3>
              <div className="invoice__payment--details">
                <ul>
                  <li>NAME: Miss AD Croning</li>
                  <li>BSB: 084 566 </li>
                  <li>A/C: 369 206 711</li>
                </ul>
                <ul>
                  <li>PAYID: 0493 294 665</li>
                  <li>
                    REFERENCE: {booking.invoiceNumber} {booking.name}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

        {printMode === "full" && (
          <div className="invoice__payment-information--container1">
            <p>
              PLEASE NOTE WE REQUIRE A NON REFUNDABLE PAYMENT OF{" "}
              <strong>$100.00</strong> TO SECURE YOUR PICNIC HIRE BOOKING
            </p>
            {formattedDueDate && (
              <p>
                REMAINING BALANCE PAYMENT IS REQUIRED BY{" "}
                <strong>
                  {formattedDueDate.toLocaleString("en-AU", {
                    timeZone: "Australia/Brisbane",
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}{" "}
                </strong>
              </p>
            )}

            <div className="invoice__payment--container">
              <h3>Payment: Direct Deposit</h3>
              <div className="invoice__payment--details">
                <ul>
                  <li>NAME: Miss AD Croning</li>
                  <li>BSB: 084 566 </li>
                  <li>A/C: 369 206 711</li>
                </ul>
                <ul>
                  <li>PAYID: 0493 294 665</li>
                  <li>
                    REFERENCE: {booking.invoiceNumber} {booking.name}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="invoice__actions--container">
        <button
          className="invoice__button my-btn"
          onClick={() => navigate(`/dashboard/bookings/${id}`)}
        >
          Booking Details
        </button>

        <button className="invoice__button my-btn" onClick={handlePrintFull}>
          Print Invoice
        </button>

        <button
          className="invoice__button my-btn"
          onClick={handlePrintFinalStatement}
        >
          Print Final Receipt
        </button>
      </div>
    </div>
  );
}
